import { SupportRequestSubmitRequest } from '@/modules/common/types/request/support-request';
import { axiosInstance } from '@/utils/axios';

import { ApiErrorCode, withApiErrorHandler } from './errors';

/**
 * Submits a support request with a user's issue description.
 * @param message - The support request message (10-1000 characters)
 */
export const createSupportRequest = async (message: string): Promise<void> => {
  const endpoint = '/api/support-requests';

  const requestBody: SupportRequestSubmitRequest = {
    message,
  };

  await withApiErrorHandler(endpoint, ApiErrorCode.SUPPORT_REQUEST_CREATE_FAILED, () =>
    axiosInstance.post(endpoint, requestBody)
  );
};
